/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMathEqualLower = createReactComponent("math-equal-lower", "IconMathEqualLower", [
  ["path", { d: "M19 18l-14 -4", key: "svg-0" }],
  ["path", { d: "M19 14l-14 -4l14 -4", key: "svg-1" }]
]);

export { IconMathEqualLower as default };
//# sourceMappingURL=IconMathEqualLower.js.map
